import { futureValueLumpsum, futureValueSIP, futureValueLumpsumPlusSIP } from "../../engine/calculations";

const fvLumpsumPlusSipConfig = {
  key: "fv-lumpsum-plus-sip",
  title: "Future Value of Lumpsum + SIP",
  category: "Growth",
  description: "Combine a one-time investment with an ongoing monthly SIP and see the total future value.",
  fields: [
    { key: "lumpsum", label: "One-time investment", type: "currency", default: 5_00_000, min: 0, max: 10_00_00_000 },
    { key: "monthly", label: "Monthly SIP amount", type: "currency", default: 10_000, min: 0, max: 10_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Investment period (years)", type: "number", default: 10, min: 1, max: 40 },
  ],
  chart: {
    type: "bar",
    xKey: "name",
    series: [{ key: "amount", label: "Amount", colorVar: "--gold" }],
  },
  compute(values) {
    const lumpsum = Number(values.lumpsum) || 0;
    const monthly = Number(values.monthly) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const lumpsumFV = futureValueLumpsum(lumpsum, annualRate, years);
    const sipFV = futureValueSIP(monthly, annualRate, years * 12);
    const futureValue = futureValueLumpsumPlusSIP(lumpsum, monthly, annualRate, years);
    const totalInvested = lumpsum + monthly * years * 12;

    return {
      headline: { label: "Future Value", value: futureValue },
      breakdown: [
        { label: "From the lumpsum", value: lumpsumFV },
        { label: "From the SIP", value: sipFV },
        { label: "Total Invested", value: totalInvested },
        { label: "Estimated Gains", value: futureValue - totalInvested },
      ],
      series: [
        { name: "Lumpsum leg", amount: lumpsumFV },
        { name: "SIP leg", amount: sipFV },
      ],
    };
  },
};

export default fvLumpsumPlusSipConfig;
